import request from '@/utils/request'
import store from '@/store'
export default {
  // 2026-09-22：量体备注与照片只按可信明细更新，服务端校验归属及并发原值。
  getMeasurementRemark: (orderDetailId: number) => request({url:'order/measurementRemark',method:'GET',params:{orderDetailId}}),
  updateMeasurementRemark: (data: {orderDetailId:number;measurementRemark:string;expectedMeasurementRemark:string}) => request({url:'order/measurementRemark',method:'PUT',data}),
  uploadOrderBodyImage: (orderId:number,data:FormData) => request({url:'order/bodyImage',method:'POST',params:{orderId},data,headers:{'Content-Type':'multipart/form-data'}}),
  deleteOrderBodyImage: (id:number) => request({url:'order/bodyImages',method:'DELETE',params:{id}}),
  getOrders: (data) => {
    return request({
      url: 'order/searchOrders',
      method: 'POST',
      data
    })
  },
  // 2026-08-26：管理端按可信订单明细保存主订单备注/留言，避免前端误传主单归属。
  // 2026-08-27：附带页面原留言用于服务端并发冲突校验。
  updateOrderComments: (data: { orderDetailId: number; comments: string; expectedComments: string }) => {
    return request({
      url: 'order/comments',
      method: 'PUT',
      data
    })
  },
  getAfterSalesOrders: (data) => {
    return request({
      url: 'order/searchAfterSalesOrders',
      method: 'POST',
      data
    })
  },
  getClothAfterSalesOrders: (data) => {
    return request({
      url: 'order/clothAfterSalesOrders',
      method: 'POST',
      data
    })
  },
  getBodyImagesByOrderId: (id) => {
    return request({
      url: `order/bodyImagesByOrderId?orderId=${id}`,
      method: 'GET'
    })
  },
  // 2026-08-02：管理端线下量体增加保存客户体型照片接口。
  addBodyImages: (data) => {
    return request({
      url: 'order/bodyImages',
      method: 'POST',
      data
    })
  },
  getUndispatchClothOrders: (data) => {
    return request({
      url: 'order/undispatchClothOrders',
      method: 'POST',
      data
    })
  },  
  updateAfterSalesOrder:(data) => {
    return request({
      url: 'order/updateAfterSalesOrder',
      method: 'POST',
      data
    })
  },
  getCustomBokeOrders: (data) => {
    return request({
      url: 'order/searchCustomOrders',
      method: 'POST',
      data
    })
  },  
  getClothOrders: (data) => {
    return request({
      url: 'order/searchClothOrders',
      method: 'POST',
      data
    })
  },  
  finishRefund: (data) => {
    return request({
      url: 'order/finishRefund',
      method: 'POST',
      data
    })
  },
  refound: (data) => {
    return request({
      // 2026-08-14: refunds require authenticated backend order permission checks.
      url: 'order/paymentRefund',
      method: 'POST',
      data
    })
  },
  // 2026-08-21：电子版明细退款只提交明细ID和原因，金额、支付渠道及状态由后端可信处理。
  refundElectronicOrderDetail: (data: { orderDetailId: number; refundReason: string; refundAmount?:number }) => {
    return request({
      url: 'order/electronicDetailRefund',
      method: 'POST',
      data
    })
  },
  // 2026-09-27：电子/纸质逐尺码统一报价与退款，可信上限和支付路由由后端复核。
  patternDetailRefundQuote: (orderDetailId:number) => request({url:'order/patternDetailRefundQuote',method:'GET',params:{orderDetailId}}),
  refundPatternOrderDetail: (data:{orderDetailId:number;refundReason:string;refundAmount:number}) => request({url:'order/patternDetailRefund',method:'POST',data}),
  updateWholesaleprice: (data) => {
    return request({
      url: 'order/updateWholesaleprice',
      method: 'POST',
      data
    })
  },
  modifyOrderPrice: (data) => {
    return request({
      url: 'order/orderModifyRecord',
      method: 'POST',
      data
    })
  },
  addChatMessage: (data) => {
    return request({
      url: 'order/chatMessage',
      method: 'POST',
      data
    })
  },
  getChatMessage: (orderId,opid) => {
    return request({
      url: `order/chatMessage?orderId=${orderId}&operatorId=${opid}`,
      method: 'GET',
      
    })
  },
  orderStatus: (id) => {
    return request({
      url: `order/orderStatus?id=${id}`,
      method: 'GET',      
    })
  },
  getOrderStatus: (id) => {
    return request({
      url: `order/orderStatus?id=${id}`,
      method: 'GET',      
    })
  },
  getOdAttach: (id) => {
    return request({
      url: `order/odAttach?orderId=${id}`,
      method: 'GET',
    })
  },
  addOdAttach: (data) => {
    return request({
      url: 'order/odAttach',
      method: 'POST',
      data
    })
  },
  // 2026-08-16：电子版附件交付由后端原子校验机构、权限、订单类型及状态。
  deliverElectronicOrder: (data) => {
    return request({
      url: 'order/deliverElectronicOrder',
      method: 'POST',
      data
    })
  },
  setOutOrder: (out,id,dispatchAmount) => {
    return request({
      url: `order/setOutOrder?outOrder=${out}&id=${id}&dispatchAmount=${dispatchAmount}`,
      method: 'GET',
    })
  },
  deleteOdAttach: (id) => {
    return request({
      url: `order/odAttach?id=${id}`,
      method: 'DELETE',
    })
  },
  getOrderOrgs: (data) => {
    return request({
      url: `order/orderOrgs`,
      method: 'POST',
      data
    })
  },
  getBokeOrderOrgs: (data) => {
    return request({
      url: `order/bokeOrderOrgs`,
      method: 'POST',
      data
    })
  },
  // 2026-08-17：管理端只提交订单号和物流绑定标识；收件人、交易号、路径及商品信息由后端可信重建。
  placeManagementShippingOrder: (data: any,timeout=60000) => {
    return request({
      url: 'order/placeShippingOrder',
      method: 'POST',
      data:{
        order_id:data.order_id,
        delivery_id:data.delivery_id,
        biz_id:data.biz_id
      },
      timeout
    })
  },
  // 2026-08-14：物流账号管理改由鉴权后台识别当前机构，禁止客户端传入 orgId/type 越权绑定。
  getShippingCompanies: () => {
    return request({
      url: 'system/shipping/companies',
      method: 'GET',
    })
  },
  getShippingAccounts: () => {
    return request({
      url: 'system/shipping/accounts',
      method: 'GET',
    })
  },
  bindShippingAccount: (data: { delivery_id: string; biz_id: string; password: string }) => {
    return request({
      url: 'system/shipping/accounts/bind',
      method: 'POST',
      data
    })
  },
  unbindShippingAccount: (data: { delivery_id: string; biz_id: string }) => {
    return request({
      url: 'system/shipping/accounts/unbind',
      method: 'POST',
      data
    })
  },
  getDelivers: (orgId) => {
    return request({
      url: `system/delivers?orgId=${orgId}`,
      method: 'GET',
    })
  },
  isAccepted: (id,orgId) => {
    return request({
      url: `order/accepted?id=${id}&orgId=${orgId}`,
      method: 'GET',
    })
  },
  getUnacceptClothOrders: (data: any) => {
    return request({
      url: 'order/unacceptClothOrders',
      method: 'POST',
      data
    })
  },
  getDispatchedClothOrders: (data: any) => {
    return request({
      url: 'order/dispatchedClothOrders',
      method: 'POST',
      data
    })
  },
  
  myMessages:()=>{
    return request({
      url: `order/messages`,
      method: 'GET',
    })
  },
  getCountOfmessages:()=>{
    return request({
      url: `order/countOfmessages`,
      method: 'GET',
    })
  },
  setMessageReaded:()=>{
    return request({
      url: `order/messageReaded`,
      method: 'GET',
    })
  },
    updateOrderSizeData: (data: any) => {
      return request({
        url: 'order/orderSizeData',
        method: 'POST',
        data
      })
    },
  updateOrderStatus: (data: any) => {
    return request({
      url: 'order/editOrderStatus',
      method: 'POST',
      data
    })
  },
  updateRefundStatus: (data: any) => {
    return request({
      url: 'order/updateRefundStatus',
      method: 'POST',
      data
    })
  },  
  getRefundOrgOrders: (data: any) => {
    return request({
      url: 'order/refundOrgOrders',
      method: 'POST',
      data
    })
  },
   getOdRefundAttachs: (refundId) => {
    return request({
      url: `order/odRefundAttachs?refundId=${refundId}`,
      method: 'get'
    })
  },
  patchUpdateOrderStatus: (data: any,timeout=60000) => {
    return request({
      url: 'order/patchEditOrderStatus',
      method: 'POST',
      timeout,
      data
    })
  },
  getShippingPath: (data: any,type) => {
    return request({
      url: 'wx/getShippingPath?type='+type,
      method: 'POST',
      data
    })
  },
  getAccountHistories: (data: any) => {
    return request({
      url: 'client/accountHistories',
      method: 'POST',
      data
    })
  },
  saveAccount: (data: any) => {
    return request({
      url: 'client/saveAccount',
      method: 'POST',
      data
    })
  },
  getPaymentInfoByOrgId: (data) => {
    return request({
      url: `order/paymentInfoByOrgId`,
      method: 'POST',
      data      
    })
  },
  updateOrderDetailStatusByOrderId: ({orderId,status}) => {
    return request({
      url: `order/updateOrderDetailStatusByOrderId?orderId=${orderId}&status=${status}`,
      method: 'GET'
    })
  },
  saveOrgOrder: (data: any) => {
    return request({
      url: 'order/orgOrder',
      method: 'POST',
      data
    })
  },
  saveCourseInstallation: (data: any) => {
    return request({
      url: 'order/courseInstallation',
      method: 'POST',
      data
    })
  },
  searchCourseOrders: (data: any) => {
    return request({
      url: 'order/searchCourseOrders',
      method: 'POST',
      data
    })
  },
  saveAftersalesOrder: (data: any) => {
    return request({
      url: 'order/aftersalesOrder',
      method: 'POST',
      data
    })
  },
  getOrderModifyRecords: (id) => {
    return request({
      url: `order/orderModifyRecords?orderId=${id}`,
      method: 'GET'
    })
  },
  getOrderInfoById: (id) => {
    return request({
      url: `order/orderInfoById?id=${id}`,
      method: 'GET'
    })
  },
  
  // 2026-09-27：同主单全部有效电子码由后端确定，异常向页面反馈。
  getBokeOrderAttachFiles: async ({orderId}:{orderId:number}):Promise<Blob> => {
    const response=await fetch(process.env.VUE_APP_BASE_API+`/order/bokeOrderAttachs?orderId=${encodeURIComponent(orderId)}`,{
      method:'GET',headers:{token:store.getters.token}
    })
    if(!response.ok || /json|text\//i.test(response.headers.get('content-type') || '')){
      let errorMessage=`下载失败（${response.status}），请刷新订单后重试。`
      try{const error=await response.json();errorMessage=error.message || errorMessage}catch(error){/* 保留状态提示 */}
      throw new Error(errorMessage)
    }
    const blob=await response.blob()
    if(!blob.size) throw new Error('订单附件为空，请刷新订单后重试。')
    return blob
  },
  getExpressInfo:(data)=>{
    return request({
      url: `expressDelivery/queryTrack`,
      method: 'POST',
      data
    })
    
  },
  getPrintOrders:(data)=>{
    return request({
      url: `order/printOrders`,
      method: 'POST',
      data
    })
    
  },
  getOrder: (id) => {
    return request({
      url: `order/order/${id}`,
      method: 'GET',
    })
  },
  getRenewalOrders: (data) => {
    return request({
      url: `client/renewalsByCustomerId`,
      method: 'POST',
      data
    })
  },
  depositesByOrgs: (data) => {
    return request({
      url: `client/depositesByOrgs`,
      method: 'POST',
      data
    })
  },
  getOrgRenewOrders: (data) => {
    return request({
      url: `client/orgRenewOrders`,
      method: 'POST',
      data
    })
  },
  addOrgRenewOrders: (data) => {
    return request({
      url: `client/addOrgRenewOrder`,
      method: 'POST',
      data
    })
  },
  getAttachFiles: ({orderId,type,downBoke},callback) => {
    const myHeaders = new Headers();
      myHeaders.append("token", store.getters.token);
      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      fetch(process.env.VUE_APP_BASE_API+`/order/odAttachFiles?orderId=${orderId}&type=${type}&downBoke=${downBoke}`, requestOptions as any)
        .then(response => {
          if (!response.ok) {
            throw new Error(`网络错误！状态码: ${response.status}`);
          }
          return response.blob();
        })
        .then(blob => {
          if(callback){
            callback(blob)
          }          
        })
        .catch(error => console.error('Error:', error));
  },
}
